import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "list", "option", "hiddenId", "hiddenKeynote"];

  connect() {
    this.hideList();
  }

  filter() {
    const query = this.inputTarget.value.toLowerCase();
    const hasResults = this.updateOptionsVisibility(query);

    hasResults ? this.showList() : this.hideList();
    this.updateHiddenFields();
  }

  updateOptionsVisibility(query) {
    let hasResults = false;

    this.optionTargets.forEach((option) => {
      const isVisible = option.textContent.toLowerCase().includes(query);
      option.classList.toggle("hidden", !isVisible);
      if (isVisible) hasResults = true;
    });

    return hasResults;
  }

  updateHiddenFields() {
    if (this.hasHiddenIdTarget && this.hasHiddenKeynoteTarget) {
      this.hiddenIdTarget.value = ""; // No se está usando un subject existente
      this.hiddenKeynoteTarget.value = this.inputTarget.value;
    }
  }

  select(event) {
    const selectedText = event.target.dataset.value;
    const selectedId = event.target.dataset.id;

    this.inputTarget.value = selectedText;
    this.updateSelectedFields(selectedId);

    this.hideList();
  }

  updateSelectedFields(selectedId) {
    if (this.hasHiddenIdTarget && this.hasHiddenKeynoteTarget) {
      this.hiddenIdTarget.value = selectedId; // Guardar el subject_id
      this.hiddenKeynoteTarget.value = ""; // No enviar keynote porque es un subject existente
    }
  }

  showList() {
    this.listTarget.classList.remove("hidden");
  }

  hideList() {
    setTimeout(() => this.listTarget.classList.add("hidden"), 200);
  }
}
